<template>
  <base-shape-dialog
    :title="'house.param.floorShape.title' | i18n"
    :subtitle="'house.param.floorShape.subtitle' | i18n"
    :description="'house.param.floorShape.description' | i18n"
    v-model="shape" />
</template>


<script>
  import Vue from 'vue'
  import BaseShapeDialog from "./BaseShapeDialog"
  import { roomShapes } from '../../api/constants'

  export default {
    computed: {
      shape: {
        get() {
          return this.$store.state.houseParams.shape
        },
        set(shape) {
          this.$store.commit('houseParams/SET_SHAPE', shape)
        }
      }
    },

    created() {
      if(this.shape == null) {
        this.$store.commit('houseParams/SET_SHAPE', roomShapes[0])
      }
    },

    components: {
      BaseShapeDialog
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dialog/HouseShapeDialog.vue